import React from 'react';
import { AuthTabs, OtpWhatsAppButton } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';

// Mobile Login (phone browsers and the APK) — full width, large tap targets.
// Mobile number first; then a password (staff) or a WhatsApp OTP (invited
// guest). All logic is in useLogin.
export default function LoginMobile({ vm }) {
  const {
    step, mobile, setMobile, password, setPassword, otp, setOtp, reused, guestName,
    remember, setRemember, busy, err, errReason, autoChecking,
    continueWithMobile, submit, verifyGuest, resendOtp, changeNumber, forgotPassword,
  } = vm;

  if (autoChecking) {
    return (
      <div className="auth-mobile">
        <div className="auth-mobile-brand">Mehfil by Smartify</div>
        <div className="muted" style={{ marginTop: 12, fontSize: 14, textAlign: 'center' }}>Signing you in…</div>
      </div>
    );
  }

  const errBox = err && (
    <div className="auth-mobile-err">
      {err}
      {step === 'password' && errReason === 'bad_password' && (
        <> · <button type="button" className="linklike" onClick={forgotPassword}>Reset it with OTP</button></>
      )}
    </div>
  );
  const numberLine = (
    <div className="login-number">
      <span>{mobile}</span>
      <button type="button" className="linklike" onClick={changeNumber}>Change</button>
    </div>
  );

  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">Mehfil by Smartify</div>
      <div className="muted auth-mobile-sub" style={{ marginBottom: 0 }}>
        {step === 'otp' ? `Welcome${guestName ? `, ${guestName}` : ''}` : 'Sign in'}
      </div>
      {step !== 'otp' && <AuthTabs active="signin" />}

      {step === 'mobile' && (
        <form onSubmit={continueWithMobile} className="auth-mobile-form">
          <label className="field">Mobile Number
            <input type="tel" inputMode="numeric" autoComplete="tel-national" name="mobile" value={mobile} placeholder="10-digit mobile" autoFocus
              onChange={(e) => setMobile(e.target.value)} />
          </label>
          {errBox}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Checking…' : 'Continue'}
          </button>
        </form>
      )}

      {step === 'password' && (
        <form onSubmit={submit} className="auth-mobile-form">
          {numberLine}
          <label className="field">Password
            <input type="password" autoComplete="current-password" value={password} placeholder="Password" autoFocus
              onChange={(e) => setPassword(e.target.value)} />
          </label>
          <button type="button" className="linklike auth-forgot" onClick={forgotPassword}>Forgot password?</button>
          <label className="auth-mobile-check">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
            Keep me signed in on this phone
          </label>
          {errBox}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      )}

      {step === 'otp' && (
        <form onSubmit={verifyGuest} className="auth-mobile-form">
          {numberLine}
          <div className="muted auth-mobile-sub">
            {reused
              ? `Use the OTP already sent to your WhatsApp at ${fmtDateTime(reused)} (valid for 1 hour).`
              : 'We sent a 4-digit code to your WhatsApp.'}
          </div>
          <label className="field">OTP
            <input type="tel" inputMode="numeric" maxLength={4} value={otp} autoComplete="one-time-code" className="auth-mobile-otp" autoFocus
              onChange={(e) => setOtp(e.target.value)} />
          </label>
          <OtpWhatsAppButton />
          {errBox}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Verifying…' : 'Verify & Continue'}
          </button>
          <div className="auth-mobile-links">
            <button type="button" className="linklike" onClick={resendOtp} disabled={busy}>Resend OTP</button>
          </div>
        </form>
      )}
    </div>
  );
}
